export const handleNumericInput = (e, length, validation = /[0-9۰-۹٠-٩]/, maxValue) => {
    const isNumber = validation.test(e.key);
    const allowedKeys = [
        'Backspace',
        'Tab',
        'ArrowLeft',
        'ArrowRight',
        'Delete',
        'Home',
        'End',
        'Enter',
        'Ctrl',
    ];
    const isCtrlKey = e.ctrlKey &&
        ['c', 'v', 'x', 'a', 'ز', 'ر', 'ط', 'ش'].indexOf(e.key.toLowerCase()) !== -1;
    if (allowedKeys.indexOf(e.key) === -1 && !isNumber && !isCtrlKey) {
        e?.preventDefault();
        return;
    }
    // Check if text is selected
    const target = e.currentTarget;
    const selectionStart = target.selectionStart;
    const selectionEnd = target.selectionEnd;
    const hasSelection = selectionStart !== selectionEnd;
    // If text is selected and a valid number is entered, allow replacement
    if (hasSelection && isNumber) {
        const currentValue = target.value;
        const beforeSelection = currentValue.substring(0, selectionStart);
        const afterSelection = currentValue.substring(selectionEnd);
        const newValue = beforeSelection + e.key + afterSelection;
        // Check if the new value would exceed the length limit
        if (newValue.length > length) {
            e?.preventDefault();
            return;
        }
        // Check if the new value would exceed the max value
        if (maxValue !== undefined) {
            const numericValue = parseInt(newValue, 10);
            if (numericValue > maxValue) {
                e?.preventDefault();
                return;
            }
        }
        // Allow the replacement
        return;
    }
    // Prevent entering more than the specified length
    if (isNumber && target.value.length >= length && !hasSelection) {
        e?.preventDefault();
        return;
    }
    // Check if adding the new digit would exceed the max value
    if (isNumber && maxValue !== undefined) {
        const currentValue = target.value;
        const newValue = currentValue + e.key;
        const numericValue = parseInt(newValue, 10);
        if (numericValue > maxValue) {
            e?.preventDefault();
            return;
        }
    }
};
export const handlePasteInput = (e, length, validation = /[0-9۰-۹٠-٩]/, maxValue) => {
    const pastedText = e.clipboardData.getData('text');
    const target = e.currentTarget;
    const currentValue = target.value;
    // Check if text is selected
    const selectionStart = target.selectionStart;
    const selectionEnd = target.selectionEnd;
    const hasSelection = selectionStart !== selectionEnd;
    let newValue;
    if (hasSelection) {
        // Replace selected text with pasted text
        const beforeSelection = currentValue.substring(0, selectionStart);
        const afterSelection = currentValue.substring(selectionEnd);
        newValue = beforeSelection + pastedText + afterSelection;
    }
    else {
        // Insert pasted text at cursor position
        newValue = currentValue + pastedText;
    }
    // Check if the pasted text contains only valid characters
    const isValidText = pastedText
        .split('')
        .every((char) => validation.test(char));
    if (!isValidText) {
        e?.preventDefault();
        return;
    }
    // Check if the total length would exceed the limit
    if (newValue.length > length) {
        e?.preventDefault();
        return;
    }
    // Check if the new value would exceed the max value
    if (maxValue !== undefined) {
        const numericValue = parseInt(newValue, 10);
        if (numericValue > maxValue) {
            e?.preventDefault();
            return;
        }
    }
};
